import { PackageTypeForm } from "@/resources/packages/PackageTypeForm";

export function PrincipleCreate() {
  return (
    <PackageTypeForm
      action="create"
      resource="principles"
      packageType="principle"
      label="Principle"
    />
  );
}

export default PrincipleCreate;
